import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-healthpicks-operator-reset-password',
  templateUrl: './healthpicks-operator-reset-password.component.html',
  styleUrls: ['./healthpicks-operator-reset-password.component.css'],
})
export class HealthpicksOperatorResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit
{
  errorMessageDict = {
    passwordNotInput: 'パスワードを入力してください。',
    confirmPasswordNotInput: '確認用パスワードを入力してください。',
    passwordNotMatch: 'パスワードが一致していません。',
    passwordHistoryError: '別のパスワードを設定してください。（直近2回以内に使用したパスワードは設定できません）',
    weakPasswordError: 'パスワードを確認してください。',
  };

  inputState = {
    password: { isFocus: false, isShow: false },
    confirmPassword: { isFocus: false, isShow: false },
  };

  constructor(title: Title) {
    super();
    title.setTitle('新しいパスワードを設定');
  }
  ngOnInit(): void {}

  async submitChangePassword() {
    await super.submitChangePassword();
    // TODO: base の `dict` (private const) が返す日本語文字列との完全一致に依存しているため、
    //       base 側の文言変更でサイレントに無効化される。
    //       将来的には base の `dict` を export する／`error.name` ベースのフックを base に生やす
    //       などの方法で文字列比較を解消する。
    if (this.errorMessages.confirmPassword === 'このパスワードは以前使用されています。') {
      this.errorMessages.confirmPassword = this.errorMessageDict.passwordHistoryError;
    } else if (this.errorMessages.confirmPassword === '半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください') {
      this.errorMessages.confirmPassword = this.errorMessageDict.weakPasswordError;
    }
  }
}
